import { ChooseBlockchainModal } from 'src/features/white-labels/techcontemporary/shared/modals/choose-blockchain-modal';

export const useChooseBlockchain = ({
    digitalArtId,
    disableMintButtonCallback,
}: {
    digitalArtId: string;
    disableMintButtonCallback: () => void;
}) => {
    const chooseBlockchainHandler = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        ChooseBlockchainModal.open({ digitalArtId, disableMintButtonCallback });
    };

    return {
        chooseBlockchainHandler,
    };
};